import { Button, TextField, DialogActions, DialogTitle, Dialog } from "@mui/material";
import React, { useState } from "react";
import { updatePasswordAdmin } from "../../services/authService";




interface ModalProps {
  open: boolean;
  onClose: () => void;
  user: User;
}

const EditPasswordModal: React.FC<ModalProps> = ({ open, onClose, user }) => {
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");


  const handleUpdatePassword = async () => {
    setLoading(true);
    try {
      await updatePasswordAdmin(user, newPassword);
      setError("");
      setNewPassword("");
      onClose();
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">

      <DialogTitle>Actualizar Contraseña</DialogTitle>
      <div className="flex flex-col flex-grow gap-6 p-6">
        <TextField
          label="Nueva contraseña"
          fullWidth
          margin="normal"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        {error && <p style={{ color: "red" }}>{error}</p>}
      </div>

      <DialogActions>

        <Button onClick={onClose} color="primary" disabled={loading}>
          Cancelar
        </Button>

        <Button onClick={handleUpdatePassword} color="primary" variant="contained" disabled={loading}>
          {loading ? "Actualizando..." : "Actualizar"}
        </Button>

      </DialogActions>

    </Dialog>
)
};
export default EditPasswordModal;
